import React, {Component} from 'react';
import $ from 'jquery';
import 'bootstrap-slider';
import FJSliderContentHorizontal from './FJSliderContentHorizontal';

import classNames from 'classnames'
import './FJSliderInput.less';
import FJCoreUtil from "../../../core/util/FJCoreUtil";

class FJSlider extends Component {
  constructor(props) {
    super(props);
    this.sliderValue = React.createRef();
    this.sliderContent = React.createRef();
    this.state = {
      isFocus: false,
      preValue: 0,
    }
  }

  componentDidMount() {
    this.sliderValue.current.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });
  }

  _callback = (data) => {
    if (this.props.callback) {
      this.props.callback(data);
    }
    this._updateInputValue(data.value);
  };

  _inputKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.sliderValue.current.blur();
    }
  };

  _sliderInputValueChange = () => {
    let {min, max} = this.props;
    let value = this.sliderValue.current.value.trim().replace(/(%+)|(s+)/g, '');
    let _preValue = this.state.preValue.trim().replace(/(\%+)|(s+)/g, '');
    let numberWithValue = Number(value);
    value = Number.isNaN(numberWithValue) ? _preValue : FJCoreUtil.valueOfInterval(numberWithValue, min, max);
    if(this.props.showSecond && value.toString().includes('.')) {
      value = value.toString().split(".")[1].length > 1 ? _preValue : value;
    }
    $(this.sliderValue.current).val(value);
    this.updateSlider(value);
    this.props.callback({type: "slideStart", value: value});
    this.props.callback({type: "changed", value: value});
    this.props.callback({type: "slideStop", value: value});
  };

  updateSlider = (value) => {
    this.sliderContent.current.updateSlider(value);
    this._updateInputValue(value);
  };

  resetSlider = () => {
    this.sliderContent.current.resetSlider();
    $(this.sliderValue.current).val(0);
  };

  enableSlider = (toggle) => {
    this.sliderContent.current.enableSlider(toggle);
  };

  _updateInputValue = (value) => {
    let _value = value.toString();
    if (this.props.showPercentage && !this.state.isFocus) {
      if (!_value.includes('%')) {
        _value += '%';
      }
      $(this.sliderValue.current).val(_value);
    } else if (this.props.showSecond && !this.state.isFocus) {
      if (!_value.includes('s')) {
        _value += 's';
      }
      $(this.sliderValue.current).val(_value);
    } else {
      $(this.sliderValue.current).val(_value.replace('%', ''));
      $(this.sliderValue.current).val(_value.replace('s', ''));
    }
  };

  _inputFocus = () => {
    let value = $(this.sliderValue.current).val();
    this.setState({
      isFocus: true,
      preValue: value,
    }, () => {
      this._updateInputValue(value)
      this.sliderValue.current.select();
    })
  };

  _inputBlur = () => {
    this.setState({
      isFocus: false
    }, () => {
      this._updateInputValue($(this.sliderValue.current).val());
      this._sliderInputValueChange();
    })
  };

  render() {
    let {min, max, step, sliderID, name, sliderColor, disabled, hasMedian, inputClass} = this.props;
    return (
      <div className={classNames('c-toolbar__slider', {disabled})}>
        {name ? <label className="c-toolbar__slider-name">{name}</label> : null}
        <FJSliderContentHorizontal
          hasMedian={hasMedian}
          sliderColor={sliderColor}
          callback={this._callback}
          ref={this.sliderContent}
          min={min}
          max={max}
          step={step} s
          liderID={sliderID}
        />
        <input type="text"
               className={classNames("c-toolbar__slider-value", inputClass)}
               ref={this.sliderValue}
               onKeyDown={this._inputKeyDown}
               onBlur={this._inputBlur}
               onFocus={this._inputFocus}/>
      </div>
    );
  };
}

export default FJSlider;
